export default {
  functions: [
    {
      name: 'getPPProducts',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'ppProducts',
      },
    },
  ],
};
